import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { Badge } from "@shared/ui/badge";
import { Star } from "lucide-react";

interface RecentTipsProps {
  dashboardData?: {
    topTips: Array<{
      code: string;
      name: string;
      isHelpful: number;
      createdBy: string;
      createdDate: string;
      utilityService: string;
    }>;
  };
}

export const RecentTips = ({ dashboardData }: RecentTipsProps) => {
  if (!dashboardData?.topTips) return null;

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="card-heading-text">Recent Tips</CardTitle>
        <CardDescription className="card-subheading-text">Latest helpful tips with helpful counts</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {dashboardData.topTips.map((tip, index) => (
            <div key={index} className="flex items-center justify-between p-3 border rounded-lg">
              <div className="flex-1">
                <p className="font-medium text-sm line-clamp-1">{tip.name}</p>
                <div className="flex items-center gap-2 mt-1">
                  <Badge variant="secondary" className="text-xs">{tip.utilityService}</Badge>
                  <Badge variant="default" className="text-xs">
                    active
                  </Badge>
                </div>
              </div>
              <div className="flex items-center gap-1 text-sm">
                <Star className={`h-3 w-3 ${tip.isHelpful ? "text-yellow-500" : "text-gray-400"}`} />
                <span className="font-medium">{tip.isHelpful}</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};